import { format, utcToZonedTime } from 'date-fns-tz';
import { ru } from 'date-fns/locale';

export const formatInTimeZone = (date: string | number | Date, fmt: string, tz: string, locale = ru): string => {
  return format(utcToZonedTime(date, tz), fmt, { timeZone: tz, locale });
};

export const formatInUTC = (date: string | number | Date, fmt: string): string => {
  return formatInTimeZone(date, fmt, 'UTC');
};
